module.exports = __webpack_public_path__ + "img/logo.3b8a1754.png";